import type { MusicWidgetData } from '@/types';

interface MusicWidgetProps {
  data: MusicWidgetData;
}

const MusicWidget = ({ data }: MusicWidgetProps) => {
  const getEmbedUrl = (): string => {
    if (data.platform === 'spotify') {
      // Extract content type and ID, stripping optional /intl-XX/ locale prefix
      const match = data.embedUrl.match(/open\.spotify\.com\/(?:intl-[a-z]{2}\/)?(\w+)\/(\w+)/);
      if (match) {
        const [, type, id] = match;
        return `https://open.spotify.com/embed/${type}/${id}`;
      }
      return data.embedUrl.replace('open.spotify.com/', 'open.spotify.com/embed/');
    }
    if (data.platform === 'apple-music') {
      // Convert music.apple.com → embed.music.apple.com
      return data.embedUrl.replace('music.apple.com/', 'embed.music.apple.com/');
    }
    return data.embedUrl;
  };

  const getHeight = (): number => {
    if (data.platform === 'spotify') {
      const match = data.embedUrl.match(/open\.spotify\.com\/(?:intl-[a-z]{2}\/)?(\w+)\//);
      const type = match?.[1];
      if (type === 'track') return 152;
      return 352;
    }
    if (data.platform === 'apple-music') {
      // Single song (URL with ?i=trackId) = compact, album/playlist = tall
      if (data.embedUrl.includes('?i=')) return 175;
      return 450;
    }
    return 200;
  };

  return (
    <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-soft dark:shadow-none overflow-hidden">
      {data.title && (
        <div className="px-4 py-3 border-b border-gray-100 dark:border-dark-700">
          <p className="font-medium text-dark-800 dark:text-white">{data.title}</p>
        </div>
      )}
      <iframe
        src={getEmbedUrl()}
        width="100%"
        height={getHeight()}
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        className="block"
      />
    </div>
  );
};

export default MusicWidget;
